import { TextFieldModule } from '@angular/cdk/text-field';
import { Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, DefaultValueAccessor, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { IconComponent } from '@libs/components/icons';
import { TextareaInputModel } from '@libs/form/models';
import { ErrorDirective, InputAttributesDirective, InputValidatorsDirective } from '../../../directives';
import { InputBaseComponent } from '../../../models';
import { FormInputDescriptionComponent } from '../../description';
import { InputProviderFactory } from '../ng-input-provider';

@Component({
  selector: 'ui-form-textarea',
  templateUrl: './textarea.component.html',
  providers: [
    ...InputProviderFactory.getProviders(TextareaComponent),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    TextFieldModule,
    ErrorDirective,
    IconComponent,
    InputValidatorsDirective,
    InputAttributesDirective,
    FormInputDescriptionComponent,
  ],
})
export class TextareaComponent extends InputBaseComponent {
  @Input()
  public data!: TextareaInputModel;

  @ViewChild(DefaultValueAccessor, { static: true })
  public valueAccessor!: ControlValueAccessor;
}
